import React from 'react';
import { Image, ImageModifier } from '../Image';

type LinkedTeaserImageInLists = {
  pageLink: string;
  imageSrc: string;
  modifier?: ImageModifier;
};

/**
 * This is a special image with its outer container.
 * The image is linked, but the link has tabindex="-1" to be not focusable.
 * The whole block is hidden from screen readers
 * and not reachable via keyboard (too many tab stops)
 *
 * Component can deal with ON2 image (imageSrc) or a SON image object.
 */
export function LinkedTeaserImage({ pageLink, imageSrc, modifier }: LinkedTeaserImageInLists) {
  return (
    <div className="linked-teaser-image-in-lists" aria-hidden>
      <Image
        image={{ src: imageSrc, orientation: 'landscape' } as any}
        emptyAltText // it only has an empty alt, when it is wrapped in an <a>!
        modifier={modifier ?? ImageModifier.CENTER_HORIZONTAL}
        hideAdjacentImageLink
        linkUrl={pageLink}
        lazyLoading
      />
    </div>
  );
}
